/* eslint-disable */
import {extendDecorator, viewModelDecorator} from '@/js/common/Domain/Service/mixins/decorators';

import template from './template.html';
import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';

@viewModelDecorator({
    warranted: false,
})
@extendDecorator({
    template,
    bindings: {
        label: 'classes:{checked:warranted}',
        input: 'checked:warranted',
    },
})
export default class WarrantedView extends Backbone.Epoxy.View {
    initialize() {
        this.initModelEvents();
        this.render();
        this.initComponents();
    }

    initModelEvents() {
        this.viewModel.mapState({
            warranted: 'model',
        }, this.model);

        this.viewModel.on('change:warranted', (model, value) => {
            this.model.set({
                model: value,
            }, {initiator: 'view'});
        });
    }

    render() {
        this.$el.html(template());
    }

    initComponents() {
        this.warrantyTooltip = new TooltipPopoverHtml({
            el: $('.js-warranted-icon', this.$el),
        });
    }
}